import { useMediaQueries } from '@react-hook/media-query';

const useResponsive = () => {
  const { matchesAny: isMobile } = useMediaQueries({
    width: '(max-width: 540px)',
  });

  return { isMobile };
};

export default useResponsive;